import * as React from "react";
import LinkComp from "../LinkComp";
import Icon from "../Icon";
import Alert from "../Alert";
import Tabs from "../Tabs";
import svgSortAsc from "../../svgs/arrow-up.svg";
import ConfirmationDialog  from "../ConfirmDialog";
import "./CRUD.scss";
import {
    AGENT_COMMISSION_PAID,
    AGENT_COMMISSION_PROCURED,
    HOTLIST_PROPERTIES_BY_EMAIL
} from '../../consts/queries';
import filter from "../../filter";
import {executeQuery} from "../../requests/executeQuery";
import { removeDuplicateObjects, compareDates,getCurrentTrancheOnGrossAmount} from "../../utils";


/**
 * The record page frame. `forceActions` shows Edit and Delete whatever the
 * record — the page has decided the member may change it. `ownDealsOnly` is
 * the property page's "edits only their own SUMMIT deals"
 * (access-levels.js editsOwnSummitDealsOnly): it opens early SUMMIT records
 * they are on and holds back adding a record at a stage they may not.
 */
const CRUD = ({userData, ownDealsOnly = false, originalData, router, tabsData, currentPageRef = null, drawer = null, backLink, edit, children = null, state, setState, handleSubmit, extraHeaderInfo, extraInfo = null, type = "", backName = "", onBack = null, saveData, title = "", formattedOriginalData = null, formattedLoanQuotesOriginalData = null, formattedPaymentsOriginalData = null, tabsClass = '', formattedProposalOriginalData = null, hideActions = false, hideDelete = false, forceActions = false, readOnlyNotice = null, onCancel = () => {}, saveDisabled = false}) => {
    const {data, viewMode, success, emailNotificationMessages = [], accessNotice = null, locationNotice = null, error, loadError = null, errorTabs = [], currentTab, showConfirm=false, isExists=false, fileUploadInProgress=false, isBusy=false} = state;

    const handleCancel = async () => {
        if (!viewMode) {
            // Let the parent discard any of its own unsaved edit state (e.g. the
            // team member's territory rows, which live outside `data`).
            onCancel();

            if (formattedLoanQuotesOriginalData && formattedPaymentsOriginalData && formattedProposalOriginalData) {
                setState((prevState) => {
                    const newData = formattedOriginalData
                        ? { ...formattedOriginalData }
                        : { ...prevState.original };
                    newData[formattedLoanQuotesOriginalData.name] = formattedLoanQuotesOriginalData.data ? formattedLoanQuotesOriginalData.data : prevState[formattedLoanQuotesOriginalData.name];
                    newData[formattedPaymentsOriginalData.name] = formattedPaymentsOriginalData.data ? formattedPaymentsOriginalData.data : prevState[formattedPaymentsOriginalData.name];
                    return {
                        viewMode: true,
                        data: newData,
                        loanQuotesData: newData[formattedLoanQuotesOriginalData.name],
                        proposalData: formattedProposalOriginalData
                    };
                });
                await handleHotListCheckboxChange(formattedOriginalData);
                if(formattedOriginalData.TRANSACTION_TYPE === 'Extra Payment'){
                    await fetchNetFeeValue(formattedOriginalData);
                }                  
            }else if (formattedLoanQuotesOriginalData) {  
                setState((prevState) => {
                    const newData = formattedOriginalData
                        ? { ...formattedOriginalData }
                        : { ...prevState.original };
                    newData[formattedLoanQuotesOriginalData.name] = formattedLoanQuotesOriginalData.data ? formattedLoanQuotesOriginalData.data : prevState[formattedLoanQuotesOriginalData.name];
                    return {
                        viewMode: true,
                        data: newData,
                        loanQuotesData: newData[formattedLoanQuotesOriginalData.name]
                    };
                });
                await handleHotListCheckboxChange(formattedOriginalData);
                if(formattedOriginalData.TRANSACTION_TYPE === 'Extra Payment'){
                    await fetchNetFeeValue(formattedOriginalData);
                }                  
            }else if(title === 'Proposals'){
                setState((prevState) => {
                    const newData = [...prevState.original];
    
                    return {
                        viewMode: true,
                        data: newData,
                        removedCards:[]
                    };
                });
            } else {
                setState((prevState) => {
                    const newData = formattedOriginalData
                        ? { ...formattedOriginalData }
                        : { ...prevState.original };
    
                    return {
                        viewMode: true,
                        data: newData,
                    };
                });
                await handleHotListCheckboxChange(formattedOriginalData);
                if(formattedOriginalData.TRANSACTION_TYPE === 'Extra Payment'){
                    await fetchNetFeeValue(formattedOriginalData);
                } 
            }
        }else if(title === 'Proposals'){
            return;
        }
        else if(!data.DELETED){
            setState({showConfirm:true})
        }
        else toggleDelete();
    }
    const handleHotListCheckboxChange = async (originalData) => {
        const data = {...originalData};
        Promise.all([
            executeQuery({
                queryName: HOTLIST_PROPERTIES_BY_EMAIL,
                params: {
                    EMAIL_ID : userData.email,
                },
            }),
        ]).then((res) => {
            if (res && res[0] && res[0].success && res[0].data.length) {
                let hotListProperties = res[0].data[0].HOT_LIST_PROPERTIES;
                let propertiesArray = hotListProperties.split(',');
                if (propertiesArray.includes(data.ARCIMEDES_ROW_ID)) {
                    setState((prevState) => ({
                        data: {
                            ...prevState.data,
                            HOT_LIST: true
                        },
                    }));
                } else {
                    setState((prevState) => ({
                        data: {
                            ...prevState.data,
                            HOT_LIST: false
                        },
                    }));
                }
            }            
        });    
    };

    

    const fetchNetFeeValue = async (originalData) => {
        try {
        const data = {...originalData};
        const date = new Date(data && data.CLOSE_OF_ESCROW);
        const year = date.getFullYear();
        const id = data && data.LISTING_AGENT_1;
        const feeAmount = data && data.REFERRAL_FEE;
              
        if(feeAmount && year != 1970 && id){
            let q = {
                AGENT_ID: id,
                YEAR: year,
                order:'CLOSE_OF_ESCROW.asc'
            }       
            const options = filter(q, 'agent-commission');            
            Promise.all([
                executeQuery({queryName: AGENT_COMMISSION_PROCURED, options}),
                executeQuery({queryName: AGENT_COMMISSION_PAID, options})
            ]).then(res => {
                if (res && res[0] && res[0].success && Array.isArray(res[0].data) &&
                res[1] && res[1].success && Array.isArray(res[1].data)){                
                    let grossCumulative = 0;                  
                    let currentTrenche = 0;
                    let insertionIndex = 0; 
                    let paidData = removeDuplicateObjects(res[1].data.filter(property => property.MEMBER_ID === id));
                    let map = new Map();
                    res[0].data.forEach(item =>{ 
                        map.set(item.ARCIMEDES_ROW_ID, item)
                    });
                    paidData.forEach(item => {
                        if (map.has(item.ARCIMEDES_ROW_ID)) {
                            let TEAM_MEMBER_GROSS_FEE = item.TEAM_MEMBER_GROSS_FEE;
                            map.set(item.ARCIMEDES_ROW_ID, {...map.get(item.ARCIMEDES_ROW_ID), TEAM_MEMBER_GROSS_FEE});
                        } else {
                            map.set(item.ARCIMEDES_ROW_ID, item);
                        }
                    });
                    const mergedArray =  Array.from(map.values());  
                    mergedArray.sort(compareDates);
                    const newCloseDate = new Date(data.CLOSE_OF_ESCROW);
                    const index = mergedArray.findIndex(item => new Date(item.CLOSE_OF_ESCROW) > newCloseDate);
                    if (index === -1) {
                        insertionIndex = mergedArray.length-1;                        
                    } else {
                        insertionIndex = index-1;
                    }
                    mergedArray.forEach((agentObj,index) => {
                    const listingProcuredGrossFee = agentObj.LISTING_GROSS_COMMISSION ? parseFloat(agentObj.LISTING_GROSS_COMMISSION) : 0;
                    const buyingProcuredGrossFee = agentObj.BUYING_GROSS_COMMISSION ? parseFloat(agentObj.BUYING_GROSS_COMMISSION) : 0;
                    const totalProcuredGrossFee = listingProcuredGrossFee + buyingProcuredGrossFee;                       
                    grossCumulative += totalProcuredGrossFee; 
                    if(insertionIndex === index)  {
                        currentTrenche = getCurrentTrancheOnGrossAmount(grossCumulative)                        
                        return;
                    }    
                });
                                        
                setState((prevState) => ({
                    data: {
                        ...prevState.data,
                        NET_FEE: data.TRANSACTION_TYPE === 'Extra Payment' ? ((parseFloat(feeAmount.replace(/,/g, '')) * currentTrenche)).toFixed(2) : ''
                    },
                }));
            }              
            });    
        }
            
        } catch (error) {
            console.error('Failed to fetch NET_FEE:', error);
            return ''; // Return empty or fallback value if the query fails
        }
    };

    const onCloseConfirm= (val)=>{
        if(val){
            toggleDelete();
        }
        setState({showConfirm:false})
    }

    React.useEffect(() => {
        if (originalData && Object.keys(originalData).length) {
            const logginedUserName = userData.person.firstName + " "+ userData.person.lastName;
            for (let i = 1; i <= 4; i++) {
                const name = (originalData['LISTING_AGENT_' + i + '_FIRST_NAME'] || "") + ' ' + (originalData['LISTING_AGENT_' + i + '_LAST_NAME'] || "");
                if ((ownDealsOnly && (!data.LISTING_AGENT_1 || !data.LISTING_AGENT_2 )) || (ownDealsOnly && name && logginedUserName.toLowerCase()=== name.toLowerCase())) {
                    setState({ isExists: true });
                }
            }
        }
    }, [originalData])
    const toggleDelete = () => {
        if (!data.DELETED) {
            data.DELETED = "1";
            setState({data},()=> saveData(data));
        } else {
            data.DELETED = null;
            setState({data},()=> saveData(data));
        }
    };

    if (data === null) {
        return <div className="loading-container">Loading...</div>;
    } else if (data === false) {
        // A load that failed (network/exception) is not the same as a record that
        // does not exist: the record is still there and retrying may well work.
        // Saying "not found" for a transient failure sends users looking for a
        // deletion that never happened.
        return loadError
            ? <Alert type="error">{loadError}</Alert>
            : (
                <Alert type="warn">
                    {`${type.charAt(0).toUpperCase()}${type.slice(1)} not found`}
                </Alert>
            );
    } else {
        return (
            <div className="CRUD" ref={currentPageRef}>
                {drawer}
                <div className="CRUD_content">
                    <div className="page-rounded-corner-container">
                        <div className="page-header-container list">
                            {/* Browser back is right for a record opened from
                                its list — it restores the filters and the
                                scroll. A screen reached some other way says
                                where the button should go instead. */}
                            {backName && <div className="page-back-button" onClick={() => (onBack ? onBack() : history.back())}>
                                <Icon svg={svgSortAsc}/>
                                {backName}
                            </div>}
                            <ConfirmationDialog open={showConfirm}  onClose={onCloseConfirm}/>
                            <div className="page-header">
                                <div className="page-title">{edit ? title : "Add " + type}</div>
                                {!hideActions && (forceActions || (data.SOURCE=='External' || title === 'Proposals') || (isExists && data.SOURCE=="SUMMIT" && (data.STATUS=="Proposal" || data.STATUS=="Property Info" ))) && <div> {edit ? (
                                    // The same button is Cancel mid-edit and Delete at rest, so
                                    // hideDelete only takes away the second of those -- a screen
                                    // that offers editing but not deleting still needs Cancel.
                                    (hideDelete && viewMode && data.ARCIMEDES_ROW_ID) ? null : (
                                    <button className="button-new negative margin-left"
                                            onClick={handleCancel}
                                    >
                                        {viewMode && data.ARCIMEDES_ROW_ID
                                            ? data && data.DELETED === "1"
                                                ? "Undelete"
                                                : "Delete"
                                            : "Cancel"}
                                    </button>
                                    )
                                ) : (
                                    <LinkComp to={backLink}>
                                        <button className="button-new negative margin-left">Cancel</button>
                                    </LinkComp>
                                )}
                                <button
                                    form={`${type}-form`}
                                    type="submit"
                                    disabled={saveDisabled || isBusy || data.DELETED === "1" || fileUploadInProgress || (!edit && ownDealsOnly && ((data.SOURCE == 'External' && !(data.STATUS == 'Active' || data.STATUS == 'Closed')) || (data.SOURCE == 'SUMMIT' && ! (data.STATUS == 'Proposal'))))}
                                    className={`button-new positive  margin-left ${
                                        saveDisabled || data.DELETED === "1" || fileUploadInProgress ? "inactive" : ""
                                    }`}
                                >
                                    {isBusy && viewMode ? (
                                        <React.Fragment>
                                            <span className="CRUD-save-spinner" />
                                            Saving...
                                        </React.Fragment>
                                    ) : (
                                        edit ? (viewMode ? "Edit" : "Save") : "Add"
                                    )}
                                </button> </div> }
                                {extraHeaderInfo}
                            </div>
                        </div>
                    </div>
                    <div className={`page-body-container crud ${type === 'property' ? 'property' : ''}`}>
                        {success ? <Alert type="success">{success}</Alert> : null}
                        {emailNotificationMessages.map((msg, i) => (
                            <Alert type="success" key={`email-notification-${i}`}>{msg}</Alert>
                        ))}
                        {error ? <Alert type="error">{error}</Alert> : null}
                        {/* What an access level kept from being saved (access-levels.js). */}
                        {accessNotice ? <Alert type="warn">{accessNotice}</Alert> : null}
                        {/* Why the save left the map point as it was, or changed the ZIP. */}
                        {locationNotice ? <Alert type="warn">{locationNotice}</Alert> : null}
                        {readOnlyNotice ? <Alert type="info">{readOnlyNotice}</Alert> : null}
                        {errorTabs.length > 0 && currentTab !== 0 ? (
                            <Alert type="error">
                                Unable to add {type} because you have an empty mandatory field
                                on another tab.
                            </Alert>
                        ) : null}

                        <form onSubmit={handleSubmit} id={`${type}-form`} className="form-container">
                            <Tabs
                                onChangeTab={(tab) => {                                  
                                    if(tabsData[tab].name.indexOf("PROPERTY")>=0 && tabsData[tab].renderedComponent && tabsData[tab].renderedComponent.props.data && tabsData[tab].renderedComponent.props.data.ARCIMEDES_ROW_ID){
                                        router.push("/property/"+tabsData[tab].renderedComponent.props.data.ARCIMEDES_ROW_ID);                                        
                                    }
                                    setState({currentTab: tab})}
                                }
                                errorTabs={errorTabs}
                                tabsData={tabsData}
                                className={tabsClass}
                               
                            />
                        </form>

                        {extraInfo &&
                            <div className='CRUD_content_extra_info'>
                                <div className='line'/>
                                {extraInfo}
                            </div>
                        }
                    </div>
                </div>
                {children}
            </div>
        );
    }
};

export default CRUD;
